import AccountIcon from "./accountIcon.svg?react";
import AddIcon from "./addIcon.svg";
import AddFOBIndicationIcon from "./addFOBIndicationIcon.svg";
import BackWithBackgroundIcon from "./backWithBackgroundIcon.svg";
import BargeIconFO from "./bargeIcon.svg";
import BeforeButtonIcon from "./beforeButton.svg";
import BlueDotIcon from "./blueDotIcon.svg";
import BuildIconWhiteBackground from "./buildIconWhiteBackground.svg";
import CancelButton from "./cancelButton.svg";
import CheckIcon from "./checkIcon.svg";
import CheckmarkPageIcon from "./checkmarkPageIcon.svg";
import CheckmarkCircle from "./checkmarkCircle.svg";
import CheckMarkCircleIcon from "./checkMarkCircleGreen.svg";
import CityIcon from "./cityIcon.svg";
import ClockIcon from "./clockIcon.svg";
import CloseBlackWhiteIcon from "./CloseBlackWhiteIcon.svg";
import CloseButton from "./closeButton.svg";
import ContentCopyFilledIcon from "./ContentCopyFilled.svg";
import ContentPasteOutlinedIcon from "./ContentPasteOutlined.svg";
import CrossCircleIcon from "./crossCircle.svg";
import CircleCloseIcon from "./circleCloseIcon.svg";
import DestinationIcon from "./destination.svg";
import DiscrenpancyIcon from "./discrenpancy.svg";
import DollarSignIcon from "./dollarSign.svg";
import DownArrowIcon from "./downwardArrow.svg";
import DownwardArrowCity from "./downwardArrowCity.svg";
import DownwardExpandIcon from "./downwardExpand.svg";
import EditPencilBlueIcon from "./editPencilBlue.svg";
import ExclamationMark from "./exclamationMark.svg";
import ExclamationMarkTriangle from "./exclamationMarkTriangle.svg";
import ExclamationMarkWithCircle from "./exclamationMarkWithCircle.svg";
import ExitButtonIcon from "./exitButton.svg";
import FacilityIcon from "./facilityIcon.svg";
import FilterIcon from "./filterIcon.svg";
import FixArrow from "./fixArrow.svg";
import FuelPumpIcon from "./fuelPump.svg";
import GoBackIcon from "./goBackIcon.svg";
import GreenCheckMark from "./greenCheckMark.svg";
import GreenCheckMarkWithBackground from "./greenCheckMarkWithBackground.svg";
import IndicationHistoryIcon from "./indicationHitoryIcon.svg";
import InformationIcon from "./informationIcon.svg";
import InformationIconGreyBackground from "./informationIconGreyBackground.svg";
import InReviewButton from "./InReviewButton.svg";
import InterchangeIcon from "./interchange.svg";
import LandingPagePin from "./landingPagePin.svg";
import LightBulb from "./lightBulb.svg";
import ListIcon from "./listIcon.svg";
import LocationIcon from "./locationIcon.svg";
import LocationIconBlue from "./locationIconBlue.svg";
import LocationIconGrey from "./locationIconGrey.svg";
import LocationPurple from "./locationPurple.svg";
import LocationIconBlueBackground from "./locationIconBlueBackground.svg";
import LocationIconRedBackground from "./locationIconRedBackground.svg";
import LocationWithoutIcon from "./locationWithoutIcon.svg";
import MapButtonIcon from "./mapButtonIcon.svg";
import MicrosoftTeamsLogo from "./microsoftTeamsLogo.svg";
import MultiLocationsIcon from "./multiLocationsIcon.svg";
import NextButtonIcon from "./nextButton.svg";
import NewSiteArrow from "./newSiteArrow.svg";
import NoteIcon from "./noteIcon.svg";
import OriginIcon from "./origin.svg";
import OriginBuildingIcon from "./originBuildingIcon.svg?react";
import OriginCloseButtonIcon from "./originCloseButton.svg";
import PinIcon from "./pin.svg";
import PinWithSlashIcon from "./pinWithSlash.svg";
import RailIcon from "./rail.svg";
import RailIconFO from "./railIcon.svg";
import RailIconPurple from "./railIconPurple.svg";
import RedCloseIcon from "./redCloseIcon.svg";
import RedDotIcon from "./redDotIcon.svg";
import RefreshButtonIcon from "./refreshButtonIcon.svg";
import RefreshButtonIconBlue from "./refreshButtonIconBlue.svg";
import RouteArrowIcon from "./routeArrow.svg";
import SearchClear from "./searchClear.svg";
import SearchMagnifyingGlass from "./searchMagnifyingGlass.svg";
import SectionSeparatorCircle from "./sectionSeparatorCircle.svg";
import SectionSeparatorLeft from "./sectionSeparatorLeft.svg";
import SectionSeparatorRight from "./sectionSeparatorRight.svg";
import SendArrowIcon from "./sendArrow.svg";
import SendButton from "./sendButton.svg";
import ShowMe from "./showMe.svg";
import SimpleCloseIcon from "./simpleCloseIcon.svg";
import SplitIcon from "./splitIcon.svg";
import TapHereIcon from "./tapHere.svg";
import TaskCompleted from "./taskCompleted.svg";
import ThreeDotIcon from "./threeDotIcon.svg";
import TodoMarker from "./todoMarker.svg";
import TotalDolloarIcon from "./totalDollar.svg";
import TrainWhite from "./trainWhite.svg";
import TrashCanIcon from "./trashCanIcon.svg";
import TruckIconFO from "./truckIcon.svg";
import VerticalBarIcon from "./verticalBar.svg";
import ViewGuidanceIcon from "./viewGuidanceIcon.svg";
import WarningIcon from "./warning.svg";
import YellowLightBulb from "./yellowLightBulb.svg";
import XIcon from "./x.svg";
import Unchecked from "./unchecked.svg";
import Checked from "./checked.svg";
import WarningRounded from "./warningRounded.svg";


export const icons = {
  AccountIcon,
  AddIcon,
  AddFOBIndicationIcon,
  BackWithBackgroundIcon,
  BargeIconFO,
  BeforeButtonIcon,
  BlueDotIcon,
  BuildIconWhiteBackground,
  CancelButton,
  CheckIcon,
  CheckmarkPageIcon,
  CheckmarkCircle,
  CheckMarkCircleIcon,
  CircleCloseIcon,
  CrossCircleIcon,
  CityIcon,
  ClockIcon,
  CloseBlackWhiteIcon,
  CloseButton,
  ContentCopyFilledIcon,
  ContentPasteOutlinedIcon,
  DestinationIcon,
  DiscrenpancyIcon,
  DollarSignIcon,
  DownArrowIcon,
  DownwardArrowCity,
  DownwardExpandIcon,
  EditPencilBlueIcon,
  ExclamationMark,
  ExclamationMarkTriangle,
  ExclamationMarkWithCircle,
  ExitButtonIcon,
  FacilityIcon,
  FilterIcon,
  FixArrow,
  FuelPumpIcon,
  GoBackIcon,
  GreenCheckMark,
  GreenCheckMarkWithBackground,
  IndicationHistoryIcon,
  InformationIcon,
  InformationIconGreyBackground,
  InReviewButton,
  InterchangeIcon,
  LandingPagePin,
  LightBulb,
  ListIcon,
  LocationIcon,
  LocationIconBlue,
  LocationIconGrey,
  LocationIconBlueBackground,
  LocationIconRedBackground,
  LocationPurple,
  LocationWithoutIcon,
  MapButtonIcon,
  MicrosoftTeamsLogo,
  MultiLocationsIcon,
  NewSiteArrow,
  NextButtonIcon,
  NoteIcon,
  OriginIcon,
  OriginBuildingIcon,
  OriginCloseButtonIcon,
  RailIcon,
  RailIconFO,
  RailIconPurple,
  RedCloseIcon,
  RedDotIcon,
  RefreshButtonIcon,
  RefreshButtonIconBlue,
  RouteArrowIcon,
  SearchClear,
  SearchMagnifyingGlass,
  SectionSeparatorCircle,
  SectionSeparatorLeft,
  SectionSeparatorRight,
  SendArrowIcon,
  SendButton,
  ShowMe,
  SimpleCloseIcon,
  SplitIcon,
  TapHereIcon,
  TaskCompleted,
  ThreeDotIcon,
  TodoMarker,
  TotalDolloarIcon,
  TrainWhite,
  TrashCanIcon,
  TruckIconFO,
  VerticalBarIcon,
  ViewGuidanceIcon,
  WarningIcon,
  YellowLightBulb,
  PinIcon,
  PinWithSlashIcon,
  XIcon,
  Unchecked,
  Checked,
  WarningRounded,
};
export type IconTypes = keyof typeof icons;
